export default "__VITE_ASSET__CCtQZZ05__"